/**
 * Official Distribution & Release Download Links for CK Pulse
 * Serving locally via Cloudflare Edge with optimized Content-Disposition headers.
 */
export const DOWNLOAD_LINKS = {
  // Recommended Package (.ZIP avoids Chrome's raw .exe heuristic warning)
  WINDOWS_ZIP: '/downloads/CKPulse-Agent-v1.0.0-win-x64.zip',

  // Standalone Executable
  WINDOWS_EXE: '/downloads/CKPulse.Agent.exe',

  // Android Manager Application
  ANDROID_APK: '/downloads/ck-pulse-manager.apk',

  // Automated 1-Click Terminal Command
  POWERSHELL_INSTALL_CMD: 'powershell -c "Invoke-WebRequest https://ck-pulse.pages.dev/downloads/CKPulse.Agent.exe -OutFile CKPulse.exe; .\\CKPulse.exe"',
};
